<template>
  <div style="height: 100vh;width: 100vw;">
    <!-- 页头 -->
    <nav-header2 style="position: absolute;z-index: 999;"></nav-header2>
    <div style="height: 60px;"></div>
    <div style="display: flex;height: calc(100% - 60px);width: 100%;">
      <!-- 侧边栏 -->
      <side-bar></side-bar>
      <div style="flex: 1;padding: 10px;background-color: #e4e7ed;display: flex;">
        <div class="content-box" style="width: 0px;">
          <div class="table-list">
            <!-- <div class="tab">
              <span style="color: #999999;">管理员管理</span>
            </div> -->
            <div class="title-box">
              <!-- 标题 -->
              <div class="title">角色列表</div>
              <!-- 按钮 -->
              <div class="btn-box">
                <!-- <el-button>添加管理员</el-button> -->
                <!-- <div
                  class="btn"
                  @click="addadmin()"
                >添加角色</div> -->
                <!-- <div
                  class="btn"
                  @click="deleteallshow()"
                >批量删除</div>
                <div class="btn">排序</div>
                <div
                  class="btn"
                  @click="exportExcel()"
                >
                  <img
                    class="exportimg"
                    src="../assets/img/export.png"
                  >
                  导出
                </div> -->
              </div>
            </div>

            <!-- 下拉选择框 -->
            <div class="select-box" style="display: flex;">
              <!-- <div class="select">
                <el-date-picker
                  @change="changestartdate()"
                  v-model="startdate"
                  type="date"
                  placeholder="注册日期（起）"
                >
                </el-date-picker>
              </div>
              <div class="select">
                <el-date-picker
                  @change="changestartdate()"
                  v-model="enddate"
                  type="date"
                  placeholder="注册日期（止）"
                >
                </el-date-picker>
              </div> -->
              <div class="select">
                <el-input clearable v-model="searchphone" placeholder="请输入角色名称"></el-input>
              </div>
              <div class="search" @click="handleSearch()">查询</div>
              <div style="margin-left: auto;display: flex;">
                <div class="btn search" @click="addadmin()">添加</div>
                <div class="btn search" @click="handleSearch()">刷新</div>
              </div>
            </div>
            <div class="listsbox hqsjkdata">
              <div>
                <div class="networkListtitle">
                  <div class="inputcheck">
                    <!-- <div
                    class="titlebox"
                    style="width: 32px;"
                  >
                    <el-checkbox
                      v-model="checkAll"
                      @change="checkall()"
                    ></el-checkbox>
                  </div> -->
                    <div class="username titlebox">
                      名称
                    </div>
                  </div>
                  <!-- <div class="usermobile titlebox">描述</div> -->
                  <div class="userfirm titlebox">创建日期</div>
                  <!-- <div class="useremail titlebox">状态</div> -->
                  <!-- <div class="userdate titlebox">注册日期</div> -->
                  <!-- <div class="networknum titlebox">网络数量</div>
                <div class="equipmentnum titlebox">设备数量</div> -->
                  <div class="networkoperate titlebox">
                    <div style="width: 240px; ">操作</div>
                  </div>
                </div>
              </div>
              <div>
                <div class="userList" v-for="i in userList" :key="i.id">
                  <div class="inputcheck">
                    <!-- <div style="width: 32px;">
                    <el-checkbox v-model="i.checked"></el-checkbox>
                  </div> -->
                    <div class="username">{{ i.adminRoleName }}</div>
                  </div>
                  <!-- <div class="usermobile">{{ i.desc }}</div> -->
                  <div class="userfirm">{{ i.adminRoleDate }}</div>
                  <!-- <div
                  class="userfirm"
                  v-if="i.issuper == 'kaifa'"
                >开发者</div> -->
                  <!-- <div class="useremail"><el-switch
                    active-value="1"
                    inactive-value="0"
                    @change="switchtj(i)"
                    v-model="i.status"
                  >
                  </el-switch></div> -->
                  <!-- <div class="userdate">{{ time(i.date) }}</div> -->
                  <!-- <div class="networknum">{{ i.networkslen }}/{{ i.networknum }}</div>
                <div class="equipmentnum">{{ i.Memberslen }}/{{ i.equipmentnum }}</div> -->
                  <div class="networkoperate">
                    <div class="userkbtn" style="color: #f5222d" @click="shownotice(i.id)">删除</div>
                    <div class="userkbtn" @click="changenumber(i)">编辑</div>
                    <!-- <div
                    class="userkbtn"
                    @click="changerole(i)"
                  >分配权限</div> -->
                  </div>

                  <!-- 删除用户 -->
                  <div v-if="i.id == delid" class="notice">
                    <div class="overlay"></div>
                    <div class="deleteallbox">
                      <div style="padding: 20px;">提示</div>
                      <div style="text-align: center;padding: 20px 30px">确定删除此角色？删除后角色信息将会被彻底清除！
                      </div>
                      <div style="margin-top: 16px;">
                        <div style="display: flex;justify-content: flex-end;">
                          <div @click="shownotice(i)" class="addbtn" style="margin-left: 0px;">取消
                          </div>
                          <div @click="userDelete(i.id)" class="addbtn"
                               style="color: white;background-color: #1677ff;margin-left: 20px;margin-right: 15px;margin-bottom: 20px;">
                            确定
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 设定数量 -->
            <div v-if="shownumber" class="notice">
              <div class="overlay"></div>
              <div class="addbox">
                <div class="addtitle">设置数量</div>
                <div class="addtable">
                  <el-form :rules="rules" ref="form" :model="form" label-width="80px">
                    <el-form-item label="网络数量" prop="name">
                      <el-input clearable placeholder="请输入网络数量" v-model="form.networknum"></el-input>
                    </el-form-item>
                    <el-form-item label="设备数量">
                      <el-input clearable placeholder="请输入设备数量" v-model="form.equipmentnum"></el-input>
                    </el-form-item>
                  </el-form>
                  <div style="display: flex;justify-content: end;">
                    <div class="addbtn" @click="changenumber()">取消</div>
                    <div class="addbtn" @click="enternumber(i)" style="background-color: #012f55;color: white;">确认
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 删除所有展示 -->
            <div v-if="alldelete">
              <div class="overlay"></div>
              <div class="deleteallbox">
                <div style="padding: 20px;">提示</div>
                <div style="text-align: center;padding: 20px 30px">确定删除所选角色？删除后角色信息将会被彻底清除！</div>
                <div style="margin-top: 16px;">
                  <div style="display: flex;justify-content: flex-end;">
                    <div @click="deleteallcancel()" class="addbtn" style="margin-left: 0px;">取消
                    </div>
                    <div @click="deleteallenter()" class="addbtn"
                         style="color: white;background-color: #012f55;margin-left: 20px;margin-right: 15px;margin-bottom: 20px;">
                      确定
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <!-- 分页 -->
            <!-- <div class="currentpage">
              <button
                class="pagination"
                @click="goToPreviousPage()"
                :disabled="currentPage === 1"
                :class="{ 'pagination-hover': currentPage !== 1 }"
              >上一页</button>
              <span
                v-for="page in pages"
                :key="page"
              >
                <button
                  @click="goToPage(page)"
                  class="pagination2"
                  :class="{ 'pagination-active': page === currentPage }"
                >{{
                                    page }}</button>
              </span>
              <button
                class="pagination"
                @click="goToNextPage()"
                :class="{ 'pagination-hover': currentPage !== totalPages }"
                :disabled="currentPage === totalPages"
              >下一页</button>
              <span style="margin-left:10px;">总数：{{fuserList.length}}</span>
            </div> -->
            <el-pagination @size-change="handleSizeChange" style="float: right;margin-bottom: 10px;"
                           @current-change="handleCurrentChange" :current-page="current" :pager-count="5"
                           :page-sizes="[10, 20, 30, 40]" :page-size="size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="fuserList">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="title" :close-on-click-modal="false" class="select-box select-boxgly"
               :visible.sync="dialogFormVisible" width="23%" :before-close="handleClose1">
      <el-form ref="dialogformdata" :rules="rules" :model="formdata">
        <el-form-item label="角色名" prop="name">
          <el-input clearable v-model="formdata.name" placeholder="请输入角色名" minlength="5" maxlength="18"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-tree :data="dataqx" default-expand-all show-checkbox ref="tree" @check="handleNodeClick" node-key="id"
                 :props="defaultProps">
          <span class="custom-tree-node" slot-scope="{ node }">
            <span>{{ node.label }}</span>
            <!-- <span v-if="data.id == dysid">
            <el-checkbox-group v-model="data.children">
              <el-checkbox label="添加"></el-checkbox>
              <el-checkbox label="编辑"></el-checkbox>
              <el-checkbox label="删除"></el-checkbox>
            </el-checkbox-group>
          </span> -->
            <!-- <span v-if="data.children.length == 0">
            <span v-if="data.id == dysid|| data.ejqx.length>0">
              <el-checkbox-group v-model="data.ejqx">
                <el-checkbox label="添加"></el-checkbox>
                <el-checkbox label="编辑"></el-checkbox>
                <el-checkbox label="删除"></el-checkbox>
              </el-checkbox-group>
            </span>
          </span> -->
          </span>
        </el-tree>
        <!-- <el-form-item
          label="描述"
        >
          <el-input
            v-model="formdata.desc"
            placeholder="请输入描述"
            minlength="11"
            maxlength="11"
            autocomplete="off"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item
          label="状态"
        >
          <el-switch
            v-model="formdata.status"
            active-value="1"
            inactive-value="0"
          >
          </el-switch>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose1" style="padding:8px 35px;">取 消</el-button>
        <el-button type="primary" style="padding:8px 35px;background:#1677ff" @click="submitData">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="jstcbt + ':权限配置'" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-tree :data="dataqx" show-checkbox ref="tree" @check="handleNodeClick" node-key="id" :props="defaultProps">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>{{ node.label }}</span>
          <!-- <span v-if="data.id == dysid">
            <el-checkbox-group v-model="data.children">
              <el-checkbox label="添加"></el-checkbox>
              <el-checkbox label="编辑"></el-checkbox>
              <el-checkbox label="删除"></el-checkbox>
            </el-checkbox-group>
          </span> -->
          <span v-if="data.children.length == 0">
            <span v-if="data.id == dysid || data.ejqx.length > 0">
              <el-checkbox-group v-model="data.ejqx">
                <el-checkbox label="添加"></el-checkbox>
                <el-checkbox label="编辑"></el-checkbox>
                <el-checkbox label="删除"></el-checkbox>
              </el-checkbox-group>
            </span>
          </span>
        </span>
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" style="padding:8px 35px;">取 消</el-button>
        <el-button type="primary" style="padding:8px 35px;background:#1677ff" @click="submitqx">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import excel from '@/libs/excel'
import bcrypt from 'bcryptjs';

export default {
  data() {
    return {
      selectedUser: null,
      alldelete: false,
      shownumber: false,
      dialogFormVisible: false,
      dialogVisible: false,
      dataqx: [{
        id: 1,
        label: '一级 1',
        children: [{
          id: 4,
          label: '二级 1-1',
          children: [{
            id: 9,
            label: '三级 1-1-1'
          }, {
            id: 10,
            label: '三级 1-1-2'
          }]
        }]
      }, {
        id: 2,
        label: '一级 2',
        children: [{
          id: 5,
          label: '二级 2-1'
        }, {
          id: 6,
          label: '二级 2-2'
        }]
      }, {
        id: 3,
        label: '一级 3',
        children: [{
          id: 7,
          label: '二级 3-1'
        }, {
          id: 8,
          label: '二级 3-2'
        }]
      }],
      defaultProps: {
        children: 'children',
        label: 'adminMenuName'
      },
      dysid: '',
      formLabelWidth: '70px',
      title: '添加角色',
      startdate: '',
      enddate: '',
      fuserList: null,
      userList: [],
      // dataList: [],
      search: '',
      searchphone: '',
      checkAll: '',
      currentPage: 1,
      itemsPerPage: 16,
      form: {
        networknum: '',
        equipmentnum: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入角色名', trigger: 'blur'},
          {min: 1, max: 18, message: '长度在 5 到 18 个字符', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 5, max: 18, message: '长度在 5 到 18 个字符', trigger: 'blur'}
        ],
        mobile: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {min: 11, max: 11, message: '请输入正确的手机号', trigger: 'blur'}
        ]
      },
      formdata: {
        name: '',
        menu: [],
      },
      delid: '',//删除时的临时id
      ecydata: [],
      jstcbt: '',
      current: 1,
      size: 10,
    }
  },
  created() {
    this.$js.token();
    //sessionStorage.setItem('tabid', '27');
    sessionStorage.setItem('path', '/Roledata');
    sessionStorage.setItem('netpage', '1');
    this.selectuser()
    this.changeheight()
  },
  computed: {
    displayedBoxes() {
      const startIndex = this.currentPage * this.itemsPerPage - this.itemsPerPage
      const endIndex = startIndex + this.itemsPerPage
      //return this.fuserList.slice(startIndex, endIndex)
      return this.fuserList;
    },
    totalPages() {
      return Math.ceil(this.fuserList.length / this.itemsPerPage)
    },
    pages() {
      const pages = [1];
      for (let i = 2; i <= this.totalPages; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    goToPreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    goToNextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.size = val;
      this.selectuser();
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.current = val;
      this.selectuser();
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    //添加管理员
    async addadmin() {
      this.dialogFormVisible = true;
      this.title = '添加角色';
      this.formdata = {
        name: '',
        menu: [],
      };
      //this.formdata.desc = '';
      //this.formdata.status = false;
      //this.formdata.password = '';
      //this.formdata.issuper = '';
      let id = JSON.parse(sessionStorage.getItem('user')).id
      let red = await this.$apiFun.selectmadd({id});
      this.ecydata = red;
      this.dataqx = this.listToTree(red);
      this.$refs.tree.setCheckedKeys([]);
    },
    // 获取页面大小
    changeheight() {
      if (document.documentElement.clientHeight <= 800 && document.documentElement.clientHeight > 750) {
        this.itemsPerPage = 12
      } else if (document.documentElement.clientHeight <= 750 && document.documentElement.clientHeight > 720) {
        this.itemsPerPage = 11
      } else if (document.documentElement.clientHeight < 720) {
        this.itemsPerPage = 7
      }
    },
    // 删除成员
    async userDelete(id) {
      // console.log(id);
      let res = await this.$apiFun.deleterole({id});
      if (res.code == 200) {
        this.$message({
          message: res.msg,
          type: 'success'
        });
        //this.dialogFormVisible = false;
        this.delid = '';
        this.selectuser();
      }
      //alert(res)
    },
    // 当前节点的点击事件
    handleNodeClick(data, cshu) {
      //this.formdata.ejqx = [];
      console.log(data, cshu);
      this.formdata.menu = cshu.checkedKeys.concat(cshu.halfCheckedKeys);
      if (cshu.checkedKeys.indexOf(data.id) != -1) {
        // if (data.children.length == 0) {
        //   this.dysid = data.id;
        // } else {
        //   this.dysid = data.id;
        // }
        //this.dysid = data.id;
        //console.log('11111')
        this.dysid = data.id;
      } else {
        //this.dysid = cshu.checkedKeys[cshu.checkedKeys.length - 1];
        //console.log('1111')
        //let lsyjqx = this.formdata.yjqx;
        let lsejqx = this.dataqx;
        for (let f = 0; f < lsejqx.length; f++) {
          //for (let g = 0; g < lsyjqx.length; g++) {
          //console.log('2222')
          if (data.id == lsejqx[f].id) {
            //console.log('333')
            if (lsejqx[f].ejqx.length > 0) {
              this.$confirm('此操作将清除后面选项, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.$message({
                  type: 'success',
                  message: '操作成功!'
                });
                data.ejqx = [];
                this.dysid = '';
              }).catch(() => {
                this.$refs.tree.setChecked(data.id, true);
                this.$message({
                  type: 'info',
                  message: '已取消'
                });

              });
            } else {
              this.dysid = '';
            }
          }
          //}
        }
      }
      //this.dysid = data.id;
      //this.dysid = cshu.checkedKeys[cshu.checkedKeys.length - 1];
    },
    async submitqx() {
      let lsyjqx = this.formdata.yjqx;
      let lsejqx = this.dataqx;
      this.formdata.ejqx = [];
      for (let f = 0; f < lsejqx.length; f++) {
        for (let g = 0; g < lsyjqx.length; g++) {
          //console.log('000');
          //console.log(lsyjqx, lsejqx[f].id);
          if (lsyjqx[g] == lsejqx[f].id) {
            //this.formdata.ejqx = [];
            this.formdata.ejqx.push({
              ye: lsyjqx[g],
              btn: lsejqx[f].ejqx
            });
          } else {
            for (let j = 0; j < this.ecydata.length; j++) {
              if (lsyjqx[g] == this.ecydata[j].id) {
                if (this.ecydata[j].fid == lsejqx[f].id) {
                  if (lsejqx[f].children.length > 0) {
                    for (let k = 0; k < lsejqx[f].children.length; k++) {
                      if (lsyjqx[g] == lsejqx[f].children[k].id) {
                        //this.formdata.ejqx = [];
                        this.formdata.ejqx.push({
                          ye: lsyjqx[g],
                          btn: lsejqx[f].children[k].ejqx
                        });
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      //console.log(this.dataqx);
      //console.log('111');
      //console.log(this.formdata.yjqx, this.formdata.ejqx);
      this.formdata.yjqx = lsyjqx;
      let _this = this;
      //setTimeout(async function () {
      _this.formdata.ejqx = JSON.stringify(_this.formdata.ejqx);
      _this.formdata.yjqx = JSON.stringify(_this.formdata.yjqx);
      //console.log('222');
      //console.log(_this.formdata.yjqx, _this.formdata.ejqx);
      //return false;
      if (_this.formdata.yjqx != null) {
        let res = await _this.$apiFun.editrole(_this.formdata);
        _this.dialogVisible = false;
        _this.selectuser();
      } else {
        _this.$message({
          message: '请勾选要分配权限的菜单',
          type: 'warning'
        });
      }
      //}, 10000);

    },
    async changerole(i) {
      //this.selectuser();
      this.dialogVisible = true;
      this.formdata = i;
      this.jstcbt = i.adminRoleName;
      this.formdata.yjqx = JSON.parse(i.adminRoleMenu);
      //console.log(i.yjqx.split(","));
      //this.$refs.tree.setCheckedKeys(i.yjqx.split(","));
      //if(){}
      //let red = await this.$apiFun.selectmenu({ id });
      this.$nextTick(() => {
        //this.$refs.tree.setCheckedKeys([]);

        if (i.adminRoleMenu != null) {
          let hxyjqs = this.formdata.yjqx;
          //console.log(i.yjqx.split(","));
          this.$refs.tree.setCheckedKeys(hxyjqs);
          if (i.adminRoleOperate != null) {
            let hxyejqs = JSON.parse(i.adminRoleOperate);

            for (let f = 0; f < this.dataqx.length; f++) {
              for (let i = 0; i < hxyejqs.length; i++) {
                if (hxyejqs[i].ye == this.dataqx[f].id) {
                  if (hxyejqs[i].btn.length > 0) {
                    this.dataqx[f].adminRoleOperate = hxyejqs[i].btn;
                  } else {
                    this.selectuser();
                  }
                } else {
                  for (let j = 0; j < this.ecydata.length; j++) {
                    if (hxyejqs[i].ye == this.ecydata[j].id) {
                      if (this.ecydata[j].adminMenuPID == this.dataqx[f].id) {
                        for (let k = 0; k < this.dataqx[f].children.length; k++) {
                          if (hxyejqs[i].ye == this.dataqx[f].children[k].id) {
                            if (hxyejqs[i].btn.length > 0) {
                              this.dataqx[f].children[k].adminRoleOperate = hxyejqs[i].btn;
                            } else {
                              this.selectuser();
                            }
                          } else {
                            //this.selectuser();
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

          }
        } else {
          this.$refs.tree.setCheckedKeys([]);
          this.selectuser();
        }
        //let lsejqx = this.dataqx;

        //console.log(this.dataqx);
        //console.log(hxyejqs);
        //this.dysid = '';
      });
    },
    handleClose(done) {
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => {});
      this.dialogVisible = false;
    },
    // 展示删除框
    shownotice(item) {
      //   if (item.notice) {
      //     item.notice = !item.notice
      //   } else {
      //     this.fuserList.forEach(item => {
      //       item.notice = false
      //     })
      //     item.notice = !item.notice
      //   }
      this.delid = item;
    },
    //展示改变设备数量
    async changenumber(i) {
      //   this.shownumber = !this.shownumber
      //   if (i) {
      //     this.selectedUser = i
      //     this.form.networknum = i.networknum
      //     this.form.equipmentnum = i.equipmentnum
      //   }
      this.dialogFormVisible = true;
      this.title = '编辑角色';
      this.formdata.name = i.adminRoleName;
      this.formdata.menu = i.adminRoleMenu.split(',');
      let id = JSON.parse(sessionStorage.getItem('user')).id
      let red = await this.$apiFun.selectmenu({id});
      this.ecydata = red;
      this.dataqx = this.listToTree(red);
      //this.$refs.tree.setCheckedKeys(i.adminRoleMenu.split(','));
      let lszs = i.adminRoleMenu.split(',');
      let hxzhi = [];
      for (let i = 0; i < red.length; i++) {
        for (let j = 0; j < lszs.length; j++) {
          if (red[i].id == lszs[j]) {
            if (red[i].adminMenuPID != '*') {
              hxzhi.push(lszs[j]);
            }
          }
        }
      }
      this.$refs.tree.setCheckedKeys(hxzhi);
      //const selectedLeafKeys = this.dataqx.filter(node => node.isLeaf).map(node => node.id);
      //this.$refs.tree.setCheckedKeys(selectedLeafKeys);
      //this.$refs.tree.setHalfCheckedKeys(i.adminRoleMenu.split(','));
      this.formdata.id = i.id;
    },
    //改变设备数量
    async enternumber() {
      let id = this.selectedUser.id
      let networknum = this.form.networknum
      let equipmentnum = this.form.equipmentnum
      let res = await this.$apiFun.changenumber({id, networknum, equipmentnum})
      console.log(res);
      location.reload()
    },
    // 时间开始
    changestartdate() {
      this.fuserList = [];
      let start = this.startdate ? this.startdate.getTime() : 0;
      let end = this.enddate ? this.enddate.getTime() : Infinity;
      this.fuserList = this.userList.filter(item => {
        let itemDate = item.date
        return itemDate >= start && itemDate <= end;
      });

    },
    //批量删除
    deleteallshow() {
      const allFalse = this.fuserList.every(obj => obj.checked === false);
      if (allFalse) {
        alert('请选择需要删除的角色')
      } else {
        this.alldelete = true
      }
    },
    deleteallcancel() {
      this.alldelete = false
    },
    deleteallenter() {
      const startIndex = this.currentPage * this.itemsPerPage - this.itemsPerPage
      const endIndex = startIndex + this.itemsPerPage
      this.fuserList.slice(startIndex, endIndex).forEach(async item => {
        if (item.checked == true) {
          let id = item.nwid
          let res = await this.$apiFun.deleterole({id});
          //alert(res)
        }
      })
      this.alldelete = false;
      this.selectuser();
    },
    // 搜索功能
    async handleSearch() {
      this.fuserList = null;
      let id = JSON.parse(sessionStorage.getItem('user')).id
      let res = await this.$apiFun.selectrole({flag: this.searchphone});
      if (res == false) {
        console.log(res);
      } else {
        this.userList = res.data.records
        this.fuserList = res.data.total
      }
    },
    //验证方法
    async verificationbd(vala) {
      if (vala == '') {
        this.$message({
          message: '请输入角色名',
          type: 'warning'
        });
        return false;
      } else {
        if (this.title == '添加角色') {
          let data = JSON.parse(sessionStorage.getItem('user'));
          //this.formdata.username = data.name;
          this.formdata.parentid = data.parentid;
          this.formdata.menu = this.formdata.menu.join();
          let res = await this.$apiFun.addrole(this.formdata);
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: 'success'
            });
            this.dialogFormVisible = false;
            this.selectuser();
            this.handleClose1()
          }
          this.formdata = {
            name: '',
            menu: [],
          };
        } else {
          this.formdata.menu = this.formdata.menu.join();
          let res = await this.$apiFun.editrole(this.formdata);
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: 'success'
            });
            this.dialogFormVisible = false;
            this.selectuser();
            this.handleClose1()
          }
          this.formdata = {
            name: '',
            menu: [],
          };
        }
        //location.reload();
      }
    },
    isValidEmail(email) {
      var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      return emailRegex.test(email);
    },
    //提交数据
    async submitData() {

      //this.formdata.id = data.id
      this.verificationbd(this.formdata.name);
      //let res = await this.$apiFun.addnet({ netname, userid, username, parentid,label,project });

    },
    handleClose1() {
      this.dialogFormVisible = false
      this.$refs.dialogformdata?.resetFields();
    },
    // 时间戳转换
    time(date) {
      let timestamp = parseInt(date);
      let time = new Date(timestamp);
      // 获取年、月、日
      let year = time.getFullYear();
      let month = ("0" + (time.getMonth() + 1)).slice(-2); // 月份是从0开始的，所以需要加1
      let day = ("0" + time.getDate()).slice(-2);
      // 格式化日期
      let formattedDate = year + "-" + month + "-" + day;
      return formattedDate
    },
    // 全选
    checkall() {
      this.fuserList.forEach(item => item.checked = this.checkAll)
    },
    //切换状态
    async switchtj(val) {
      let res = await this.$apiFun.editrole(val);
      this.$message({
        message: res,
        type: 'success'
      });
      this.selectuser();
    },
    //导出操作
    exportExcel() {
      let List = []
      this.fuserList.forEach(item => {
        if (item.checked == true) {
          List.push(item)
        }
      })
      if (List.length > 0) {
        const params = {
          title: ['账号', '电话', '邮箱', '注册日期', '网络数量', '设备数量'],
          key: ['name', 'mobile', 'email', 'date', 'networknum', 'equipmentnum'],
          data: List, // 数据源
          autoWidth: true, //autoWidth等于true，那么列的宽度会适应那一列最长的值
          filename: '客户数据'
        }
        excel.exportArrayToExcel(params)
      } else {
        alert('请勾选需要导出的网络')
      }
    },
    listToTree(list) {
      let map = {}, node, tree = [], i;
      for (i = 0; i < list.length; i++) {
        map[list[i].id] = i; // 初始化映射
        list[i].children = []; // 初始化children数组
      }
      for (i = 0; i < list.length; i++) {
        node = list[i];
        if (node.adminMenuPID !== "*") { // 如果当前节点的parentId不是根节点的parentId，即不是根节点
          // 找到当前节点的父节点
          list[map[node.adminMenuPID]].children.push(node);
        } else {
          tree.push(node); // 如果当前节点是根节点，将其添加到树结构中
        }
      }
      return tree;
    },
    //查询用户信息
    async selectuser() {
      let Memberslen = 0
      let networkslen = 0
      let id = JSON.parse(sessionStorage.getItem('user')).id
      let issuper = JSON.parse(sessionStorage.getItem('user')).issuper
      //let res = await this.$apiFun.selectadmin({ id, issuper });
      let res = await this.$apiFun.selectrole({flag: this.searchphone, current: this.current, size: this.size});
      if (res == false) {
        console.log(res);
      } else {
        this.userList = res.data.records
        this.fuserList = res.data.total
      }

      //this.dataqx = await this.$apiFun.selectmenu({ id });
    },
    // 修改操作
    updata() {
      alert('修改还没做')
    }
  }
}
</script>

<style scoped>
.content-box {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding: 0 1.1%;
  background-color: white;
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;
}

.tab {
  font-size: 12px;
  padding-top: 10px;
  height: 38.8px;
  line-height: 38.8px;
}

.title-box {
  margin: 20px 0px 10px;
  height: 30px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
}

.title {
  font-size: 14px;
  font-weight: 700;
}

.btn-box {
  margin: -15px 0px 0px 0px;
  display: flex;
}

.addbox {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  height: 300px;
  z-index: 999;
  background-color: white;
}

.addtitle {
  padding: 25px 0px 0px 15px;
  font-size: 14px;
  font-weight: bold;
}

.addtable {
  margin-top: 40px;
  padding: 0px 80px;
}

.addbtn {
  height: 30px;
  line-height: 30px;
  background: #fafafa;
  padding: 0px 25px;
  font-size: 14px;
  border: 1px solid #dcdcdc;
  margin-left: 10px;
  cursor: pointer;
}

.notice {
  color: #333333;
  z-index: 999;
}

.overlay {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  /* 半透明黑色背景 */
  z-index: 999;
  /* 确保在上层 */
}

.deleteallbox {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  background-color: white !important;
}

/* .userkbtn:hover {
  color: #70c31d;
  cursor: pointer;
} */

.exportimg {
  width: 14px;
  height: 14px;
  margin-right: 10px;
}


::v-deep .el-dialog {
  min-height: 300px;
}

.select {
  margin: 0px 10px 20px 0px;
}

.search {
  margin: 0px 10px 20px 0px;
  line-height: 32px;
  padding: 0 16px;
  background-color: #1677ff;
  color: white;
  cursor: pointer;
  font-size: 12px;
}

.networkListtitle {
  font-size: 12px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  padding: 0 8px;
  font-weight: bold;
  background-color: #fafafb;
  border-bottom: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
}

.inputcheck {
  display: flex;
}

.username {
  width: 682px;
}

.select-box:deep(.el-input__inner) {
  width: 151px;
  height: 32px;
  font-size: 12px;
}

.select-boxgly:deep(.el-input__inner) {
  width: 100% !important;
  height: 32px;
}

.select-box:deep(.el-date-editor.el-input, .el-date-editor.el-input__inner) {
  width: 150px;
}

.select-box:deep(.el-input__icon) {
  line-height: 32px;
  font-size: 12px;
}

.select:deep(.el-input__inner:focus) {
  border-color: #012f55;
}

.select:deep(.el-input.is-focus .el-input__inner) {
  border-color: #012f55;
}

.btn {
  display: flex;
  align-items: center;
  padding: 0px 16px;
  height: 32px;
  line-height: 32px;
  margin: 0px 10px 0px 0px;
  border: 1px solid #e7e9f1;
  cursor: pointer;
  font-size: 12px;
  color: #fff;
}

.addbtn {
  height: 30px;
  line-height: 30px;
  background: #fafafa;
  padding: 0px 25px;
  font-size: 14px;
  border: 1px solid #dcdcdc;
  margin-left: 10px;
  cursor: pointer;
}

.deleteallbox {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* width: 210px; */
  /* height: 100px; */
  z-index: 999;
  background-color: white !important;
}

.userList {
  min-width: 1618px;
  display: flex;
  border-bottom: 1px solid #ebeef5;
  padding: 8px;
  font-size: 12px;
}

.userList:hover {
  background: #fafafb;
}

.usermobile {
  width: 12.3%;
  flex-shrink: 0;
}

.userfirm {
  width: 862px;
  text-overflow: ellipsis;
  overflow: hidden;
  flex-shrink: 0;
}

.useremail {
  width: 228px;
  flex-shrink: 0;
}

.userdate {
  width: 180px;
  flex-shrink: 0;
}

.networknum {
  width: 9.22%;
  flex-shrink: 0;
}

.equipmentnum {
  width: 9.22%;
  flex-shrink: 0;
}

.networkoperate {
  position: relative;
  width: 75px;
  display: flex;
  /* justify-content: space-between; */

}


.userkbtn {
  color: #1677ff;
  border: none;
  cursor: pointer;
  height: 100%;
  margin-right: 6px;

  &:last-child {
    margin-right: 0;
  }
}

.inputcheck:deep(.el-checkbox__inner) {
  background: #edf2fc;
  border-color: #dcdfe6;
}

.inputcheck:deep(.el-checkbox__inner) {
  background: #edf2fc;
  border-color: #dcdfe6;
}

.inputcheck:deep(.el-checkbox__input.is-focus .el-checkbox__inner) {
  border-color: #012f55;
}

.inputcheck:deep(.el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner) {
  background: #012f55;
  border-color: #012f55;
}

.select:deep(.el-input__inner) {
  line-height: 32px;
}

.select:deep(.el-input__inner:hover) {
  border-color: #012f55;
}

.notice:deep(.el-input__inner:focus) {
  border-color: #012f55;
}

.notice:deep(.el-input.is-focus .el-input__inner) {
  border-color: #012f55;
}

.titlebox {
  padding: 8px 0px;
  background-color: #fafafb;
}

@media screen and (min-width: 1680px) {
  .titlebox {
    padding: 8px 0px;
    border: none;
  }

  .networkListtitle {
    background-color: #fafafb;
    border-top: 1px solid #e7e9f1;
    border-bottom: 1px solid #e7e9f1;
  }
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>